import { fromJS } from 'immutable';
import createAction from '../../../utils/redux-helpers/createAction';

const handler = (state, { list }) => state.set('deliveryZones', fromJS(list));

export const setDeliveryZone = createAction({
  action: ['setDeliveryZone', 'list'],
  handler,
});
